import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import LogoDark from '@images/logoDark.svg';
export const NotFound = ({ mode = 'LOGGEDIN' }: { mode: 'LOGGEDIN' | 'LOGGEDOUT' }) => {
  const navigate = useNavigate();
  return (
    <div className={`flex items-center justify-center h-screen flex-col   align-middle `}>
      <div
        className={`flex flex-col  items-center justify-center  gap-14 ${mode === 'LOGGEDOUT' ? 'border-[1px] border-bordercolor rounded-md px-10 py-12 w-[470px] ' : ''}`}
      >
        {mode === 'LOGGEDOUT' && <img src={LogoDark} alt="logo" className="w-[135px] h-[70px]" />}

        <div className="flex flex-col gap-8 items-center justify-center ">
          <div className="text-9xl text-[#CAC8C8] font-bold">404</div>
          <div className="flex flex-col gap-3 text-center ">
            <h1 className="leading-10 text-[32px] font-normal text-black">Oops! We couldn’t find that page.</h1>
            <p className="leading-[24px] text-base font-normal text-[#71717A]">
              The page you’re looking for might have been moved, deleted, or doesn’t exist yet.{' '}
            </p>
          </div>
          {mode === 'LOGGEDIN' && (
            <Button
              variant="default"
              className="w-[163px] h-[48px] cursor-pointer"
              onClick={() => navigate('/dashboard')}
            >
              Back to Home Page
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
